import React from 'react'
import Page from '../components/Page'
import { Spinner, Button, ButtonGroup, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
// import axios from 'axios';
import axios from '../utils/posAxios'
import moment from 'moment-timezone'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdWarning, MdClear, MdCreate, MdKeyboardReturn, MdDelete, MdFileUpload, MdCancel } from 'react-icons/md'
import { BsPlusSquareFill } from 'react-icons/bs'
import { IconContext } from 'react-icons/lib'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import classnames from 'classnames'
import { getProductList, getProductCategory, getProductType } from '../utils/dropdownlist'
import update, { extend } from 'immutability-helper'
import Compress from 'compress.js'

import '../../node_modules/@syncfusion/ej2-base/styles/material.css'
import '../../node_modules/@syncfusion/ej2-icons/styles/material.css'
import '../../node_modules/@syncfusion/ej2-buttons/styles/material.css'
import '../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css'
import '../../node_modules/@syncfusion/ej2-inputs/styles/material.css'
import '../../node_modules/@syncfusion/ej2-lists/styles/material.css'
import '../../node_modules/@syncfusion/ej2-navigations/styles/material.css'
import '../../node_modules/@syncfusion/ej2-popups/styles/material.css'
import '../../node_modules/@syncfusion/ej2-richtexteditor/styles/material.css'
import { HtmlEditor, Image, Inject, Link, QuickToolbar, RichTextEditorComponent, Toolbar, NodeSelection, PasteCleanup } from '@syncfusion/ej2-react-richtexteditor'

const compress = new Compress()

class EasyParcelRequestOrder extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      store_id: this.props.data.store_id,
      delivery_collection_point: [],
      pick_name: '',
      date_coll: '',
      pick_code: '',
      pick_country: '',
      pick_unit: '',
      pick_company: '',
      pick_contact: '',
      pick_mobile: '',
      send_name: '',
      send_contact: '',
      send_mobile: '',
      send_unit: '',
      send_addr1: '',
      send_state: '',
      send_code: '',
      send_country: '',
      send_company: '',
      content: '',
      value: '',
      width: '',
      height: '',
      length: '',
      weight: '',
      order_id: '',
      price: '',
      service_name: '',
      rates: [],
      collection_point: '',
      SelectedID: '',
    }
  }

  componentDidMount() {
    let data = this.props.data
    let { collection_point, SelectedID, address, items, total_price, delivery_collection_point, send_code, send_country, rates, date_coll, order_id, width, height, length, weight } = data

    let collection = delivery_collection_point.find(x => x.id == collection_point)
    let service = rates.find(x => x.service_id == SelectedID)

    this.setState({
      pick_name: collection.pick_name,
      date_coll: service.pickup_date,
      pick_code: collection.pick_code,
      pick_country: collection.pick_country,
      pick_unit: collection.pick_unit,
      pick_company: collection.pick_company,
      pick_contact: collection.pick_contact,
      pick_mobile: collection.pick_mobile,
      send_name: address.name,
      send_contact: address.contact == null ? '' : address.contact,
      send_unit: address.unit,
      send_addr1: address.address,
      send_state: address.country,
      send_code: send_code,
      send_country: send_country,
      content: items[0].name,
      value: total_price,
      width: width,
      height: height,
      length: length,
      weight: weight,
      order_id: order_id,
      price: service.price,
      service_name: service.service_name,
      service_id: SelectedID,
    })
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  changeHandler = event => {
    const { name, value } = event.target

    this.setState({
      [name]: value,
    })
  }

  checkHandler = e => {
    let { name } = e.target
    this.setState({
      [name]: !this.state[name],
    })
  }

  DeliveryCollection() {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
    }
    axios
      .post(url + ':3003/v1/order/delivery/pickaddress', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        if (this._isMounted) {
          this.setState({
            delivery_collection_point: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  handleSubmit = event => {
    event.preventDefault()

    this.setState({ isLoading: true })

    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const comp = StorageService.getSession('selected_org')
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.props.data.store_id,
      package: {
        weight: this.state.weight,
        width: this.state.width,
        height: this.state.height,
        length: this.state.length,
      },
      content: this.state.content,
      value: this.state.value,
      service_id: this.state.service_id,
      pick_name: this.state.pick_name,
      pick_company: this.state.pick_company,
      pick_contact: this.state.pick_contact,
      pick_mobile: this.state.pick_mobile,
      pick_unit: this.state.pick_unit,
      pick_code: this.state.pick_code,
      pick_country: this.state.pick_country,
      send_name: this.state.send_name,
      send_company: this.state.send_company,
      send_contact: this.state.send_contact,
      send_mobile: this.state.send_mobile,
      send_unit: this.state.send_unit,
      send_addr1: this.state.send_addr1,
      send_state: this.state.send_state,
      send_code: this.state.send_code,
      send_country: this.state.send_country,
      collect_date: this.state.date_coll,
      order_id: this.state.order_id,
    }

    axios
      .post(url + ':3003/v1/order/delivery/ezp/createorder', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          alert(result.message)
          return
        } else {
          if (this._isMounted) {
            this.setState({
              rates: result.data.rates,
              isLoading: false,
            })

            this.props.closeModal(<MdDone />, 'Order successfully placed.', 'success', false)
          }
        }
      })
      .then(() => {
        this.setState({ isLoading: false })
      })
      .catch(error => {
        this.setState({ isLoading: false })
        alert(error)
      })
  }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        {this.state.isLoading == true && (
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              marginTop: -16,
              marginLeft: -16,
              zIndex: 1,
            }}>
            <Spinner animation="border" variant="primary" />
          </div>
        )}
        <ModalHeader toggle={this.props.onToggleModal()}>Request Order</ModalHeader>
        <ModalBody>
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card className="ps-card-display">
                <CardBody>
                  <Row form>
                    <Col lg={6}>
                      <Label>Collection Point</Label>
                      <p>{this.state.pick_name}</p>
                    </Col>
                    <Col lg={6}>
                      <Label>Pickup Date</Label>
                      <p>{this.state.date_coll}</p>
                    </Col>
                    <Col lg={4}>
                      <Label>Pickup Postal Code</Label>
                      <p>{this.state.pick_code}</p>
                    </Col>
                    <Col lg={4}>
                      <Label>Pick Country</Label>
                      <p>{this.state.pick_country}</p>
                    </Col>
                    <Col lg={4}>
                      <Label>Unit</Label>
                      <p>{this.state.pick_unit}</p>
                    </Col>
                    <Col lg={4}>
                      <Label>Company</Label>
                      <p>{this.state.pick_company}</p>
                    </Col>
                    <Col lg={4}>
                      <Label>Contact</Label>
                      <p>{this.state.pick_contact}</p>
                    </Col>
                    <Col lg={4}>
                      <Label>Mobile</Label>
                      <p>{this.state.pick_mobile}</p>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>Receiver Name*</Label>
                <Input type="text" name="send_name" value={this.state.send_name} maxLength="35" onChange={this.changeHandler} required />
              </FormGroup>
              <FormGroup>
                <Label>Receiver Company</Label>
                <Input type="text" name="send_company" value={this.state.send_company} maxLength="30" onChange={this.changeHandler} />
              </FormGroup>

              <FormGroup>
                <Label>Receiver Contact*</Label>
                <Input type="text" name="send_contact" value={this.state.send_contact} onChange={this.changeHandler} required />
              </FormGroup>

              <FormGroup>
                <Label>Receiver Mobile</Label>
                <Input type="text" name="send_mobile" value={this.state.send_mobile} onChange={this.changeHandler} />
              </FormGroup>

              <FormGroup>
                <Label>Receiver Unit*</Label>
                <Input type="text" name="send_unit" value={this.state.send_unit} maxLength="10" onChange={this.changeHandler} required />
              </FormGroup>

              <FormGroup>
                <Label>Receiver Address*</Label>
                <Input type="text" name="send_address" value={this.state.send_addr1} maxLength="35" onChange={this.changeHandler} readOnly required />
              </FormGroup>

              <FormGroup>
                <Label>Receiver State*</Label>
                <Input type="text" name="send_state" value={this.state.send_state} maxLength="10" onChange={this.changeHandler} required />
              </FormGroup>

              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label>Receiver Postal Code</Label>
                    <Input type="text" name="send_code" value={this.state.send_code} readOnly required />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Receiver Country</Label>
                    <Input type="text" name="send_country" value={this.state.send_country} readOnly required />
                  </FormGroup>
                </Col>
              </Row>

              <FormGroup>
                <Label>Content</Label>
                <Input type="text" name="content" value={this.state.content} maxLength="35" onChange={this.changeHandler} />
              </FormGroup>

              <FormGroup>
                <Label>Content Value</Label>
                <Input type="number" name="value" value={this.state.value} onChange={this.changeHandler} />
              </FormGroup>

              <Row form>
                <Col md={3}>
                  <FormGroup>
                    <Label>Width (cm)</Label>
                    <Input type="number" name="width" value={this.state.width} readOnly />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Length (cm)</Label>
                    <Input type="number" name="length" value={this.state.length} readOnly />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Height (cm)</Label>
                    <Input type="number" name="height" value={this.state.height} readOnly />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Package Weight* (kg)</Label>
                    <Input type="text" name="weight" value={this.state.weight} readOnly />
                  </FormGroup>
                </Col>
              </Row>

              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label>Reference</Label>
                    <Input type="text" name="order_id" value={this.state.order_id} readOnly />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Shipping Price</Label>
                    <Input type="number" name="price" value={this.state.price} readOnly />
                  </FormGroup>
                </Col>
              </Row>

              <FormGroup>
                <Label>Service Selected</Label>
                <Input type="text" name="service_name" value={this.state.service_name} readOnly />
              </FormGroup>

              {/* <Row style={{ float: 'right' }}>
                <Col>
                  <ButtonGroup>
                    <Button className="theme-button unity-theme-button-primary" type="submit">
                      Submit
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row> */}
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          {/* <Button className="theme-button theme-button-secondary" onClick={this.props.onToggleModal()}>
            Close
          </Button> */}
          <Button className="theme-button theme-button-primary" type="submit">
            Submit
          </Button>
        </ModalFooter>
      </Form>
    )
  }
}
export default EasyParcelRequestOrder
